import { Component, OnInit } from '@angular/core';
import { AdminScopes, AdminUser, UserService } from '@app/shared/services/user.service';
import { Router } from '@angular/router';
import { first } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-scan-events-reports',
  templateUrl: './scan-events.component.html',
})
export class ScanEventsComponent implements OnInit {
  public loading: boolean = true;
  public user: AdminUser;
  public canViewSortScanReports: boolean = false;
  public canViewPickupScanReports: boolean = false;

  public selectedTab: number = 0;
  public tabs = [
    {
      label: 'Sorts',
      id: 'app-sort-scans-reports',
      scope: [AdminScopes.VIEW_SCAN_EVENTS_SORTS],
    },
    {
      label: 'Pickups',
      id: 'app-pickup-scans-reports',
      scope: [AdminScopes.VIEW_SCAN_EVENTS_PICKUPS],
    },
  ];

  constructor(private userService: UserService, private router: Router) {}

  ngOnInit() {
    this.loading = true;
    // Don't pass scopes here - let user through, then gate tabs individually.
    // Backend endpoints still enforce scopes via @ScopesDecorator() + @UseGuards().
    this.userService
      .getAuthenticatedUser([])
      .pipe(first())
      .subscribe(
        (adminUser: AdminUser) => {
          if (adminUser) {
            this.user = adminUser;
            // Gate each tab based on specific scope
            this.canViewSortScanReports =
              this.userService.hasAuthScope(this.user, [AdminScopes.VIEW_SCAN_EVENTS_SORTS]) ||
              this.userService.hasAuthScope(this.user, [AdminScopes.VIEW_SCAN_EVENTS_SORTS_APPLEEXPRESS]);
            this.canViewPickupScanReports =
              this.userService.hasAuthScope(this.user, [AdminScopes.VIEW_SCAN_EVENTS_PICKUPS]) ||
              this.userService.hasAuthScope(this.user, [AdminScopes.VIEW_SCAN_EVENTS_PICKUPS_APPLEEXPRESS]);
            // If user has neither scope, redirect to home
            if (!this.canViewSortScanReports && !this.canViewPickupScanReports) {
              this.router.navigate(['home']);
              return;
            }

            // Set initial selected tab based on available permissions
            if (!this.canViewSortScanReports && this.canViewPickupScanReports) {
              this.selectedTab = 1; // Select Pickups tab if user can only view pickups
            }

            this.loading = false;
          } else {
            this.router.navigate(['login']);
          }
        },
        (err) => {
          this.router.navigate(['home']);
        }
      );
  }
}
